import { formatAddress } from 'common/utils'
import { NAMESPACE } from 'locale'
import { generalConstants } from 'locale/general'
import { reportsConstants } from 'locale/team'
import { useTranslation } from 'react-i18next'
import EditProfileCard from '../../../../components/forms/screens/TeamMemberEditFormV2/EditProfileCard'
import { fmtDate } from '../../utils/dateUtils'
import ProfileFieldRow, { ProfileFieldGrid } from './ProfileFieldRow'

type Props = { profile: Record<string, any>; t: (k: string) => string }

const PersonalDetailsViewCard = ({ profile, t }: Props) => {
  const { t: tGeneral } = useTranslation(NAMESPACE.GENERAL)

  return (
    <EditProfileCard
      title={t(reportsConstants.PROFILE_VIEW_CARD_PERSONAL)}
      testId="profile-view-personal"
      showTitleDivider
      fullWidth
    >
      <ProfileFieldGrid>
        <ProfileFieldRow
          label={t(reportsConstants.PROFILE_VIEW_DOB)}
          value={fmtDate(profile.dateOfBirth)}
        />
        <ProfileFieldRow
          label={t(reportsConstants.PROFILE_VIEW_PHONE)}
          value={profile.phoneNumber}
        />
        <ProfileFieldRow
          label={t(reportsConstants.PROFILE_VIEW_ADDRESS)}
          value={profile.address ? formatAddress(profile.address) : ''}
        />
        <ProfileFieldRow
          label={t(reportsConstants.PROFILE_VIEW_ALLERGIES)}
          value={profile.hasAllergies}
        />
        {profile.hasAllergies === 'Yes' && (
          <ProfileFieldRow
            label={t(reportsConstants.PROFILE_VIEW_ALLERGY_DETAILS)}
            value={profile.allergies}
          />
        )}
        {profile.customId && (
          <ProfileFieldRow
            label={tGeneral(generalConstants.CUSTOM_ID)}
            value={profile.customId}
          />
        )}
      </ProfileFieldGrid>
    </EditProfileCard>
  )
}

export default PersonalDetailsViewCard
